import { Loader2 } from 'lucide-react';
const Spinner = ({ size = 'sm' }) => <Loader2 className={`animate-spin text-pw-primary ${size === 'sm' ? 'w-4 h-4' : 'w-6 h-6'}`} />;
export default Spinner;
